import React from 'react';
import { motion } from 'framer-motion';
export function ReframeSection() {
  return <section className="px-6 py-32 md:py-40 bg-black text-white pt-[0px] pb-[0px]" data-id="element-88">
      <div className="w-full max-w-4xl mx-auto text-center" data-id="element-89">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight mb-10 leading-[1.05]" data-id="element-90"></motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-2xl md:text-3xl text-gray-400 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-91"></motion.p>
      </div>
    </section>;
}